import axios from 'axios';

export default {
  loadChildCare () {
    return new Promise(resolve => {
      axios.get(`https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/ChildCareProgram.json?&timestamp=${new Date().getTime()}`).then((result) => {
        let data = result.data
        data.map(r => {
          r.name = r['Child Care Center Name']
          r.contact = r['Contact Person']
          if (r['Website']) {
            if (r['Website'].indexOf('http') === -1) {
              r['Website'] = `http://${r['Website']}`
            }
          }
          r.type = 'ChildCare'
          r.lat = parseFloat(r.Lat)
          r.lng = parseFloat(r.Lng)
        })
        resolve(data);
      });
    })
  },
  loadFamilyDayCare () {
    return new Promise(resolve => {
      axios.get(`https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/FamilyDayCareProgram.json?&timestamp=${new Date().getTime()}`).then((result) => {
        let data = result.data
        data.map(r => {
          r.name = r['Provider Name']
          r.contact = r['Provider Name']
          if (r['Website']) {
            if (r['Website'].indexOf('http') === -1) {
              r['Website'] = `http://${r['Website']}`
            }
          }
          r.type = 'FamilyCare'
          r.lat = parseFloat(r.Lat)
          r.lng = parseFloat(r.Lng)
        })
        resolve(data);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/childCarePrograms/childCarePrograms.service.js